module.exports = __webpack_public_path__ + "img/randomimage (5).5491a66c.png";